module.exports = __webpack_public_path__ + "img/OTHER.1e10253e.png";